import { render } from "./PlanView.vue?vue&type=template&id=4b417cd0"
import script from "./PlanView.vue?vue&type=script&lang=js"
export * from "./PlanView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__